module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEmSURBVEhL3ZQ9SgNBGIZXFImI2oliL3gHSyttAp7CwkqvEC0svYF4A72B4s8VBO0iaKUWFkmIPu9kPxmGnZ3Z2IQ88MB+X953d1iSFFPPDO7gJb7gd6muL1Cfjc0KXuNPwitUthFzeI+6wRse4Ra2SnV9jO+ozB2qk80hqviM61pE2EC9LmUPtMjlEVVqu6mefVT2wU2ZfKFKS26qZxmV/XTTJKDT/MckVaUmJvGDZ+iXQ/fQsF0SP7iIPbTdLm568ywatksSBp9Qc99Nox+aZRa0KAl7UcLgB9puVQu4xZvR5R9hL4ofnMch2m4NY/i9WsKg/jUHeO6mOGM/IJfJecArKrjtpjyUVafrpgSnaKdpageT6JtzgjpN1U2qVFYddaeKovgFRV6eaG0m2ssAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-bucket/dark/24.png
// module id = 2300
// module chunks = 2